import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import { uuidPattern } from "@/lib/raft_generic_helper";

const RequirementExemptionForm = () =>
  import("@/components/requirements/RequirementExemptionForm.vue");
const UserRequirementExemptionListing = () =>
  import("@/components/requirements/UserRequirementExemptionListing.vue");
const InstitutionalRequirementExemptionListing = () =>
  import(
    "@/components/requirements/InstitutionalRequirementExemptionListing.vue"
  );

require("../../css/FixTableColumn.css");
require("./css/requirements.css");

const options = {
  color: "#41b883",
  failedColor: "#874b4b",
  thickness: "8px",
  transition: {
    speed: "0.02s",
    opacity: "0.8s",
    termination: 9000,
  },
  autoRevert: true,
  autoFinish: false,
  location: "top",
  inverse: false,
};
Vue.use(VueProgressBar, options);

const routes = [
  {
    path: "/raft/requirements/exemptions",
    component: InstitutionalRequirementExemptionListing,
    name: "requirement_exemption_listing",
  },
  {
    path: "/user/:userUid([0-9]+)/requirements",
    component: UserRequirementExemptionListing,
    name: "user_requirement_exemption_listing",
    props: (route) => ({
      userUid: Number.parseInt(route.params.userUid, 10),
    }),
  },
  {
    path: "/user/:userUid([0-9]+)/requirements/exemptions/create",
    component: RequirementExemptionForm,
    name: "requirement_exemption_form_create",
    props: (route) => ({
      userUid: Number.parseInt(route.params.userUid, 10),
      isGlobal: true,
    }),
  },
  {
    path:
      "/user/:userUid([0-9]+)/requirements/exemptions/edit/:exemptionUuid(" +
      uuidPattern +
      ")?",
    component: RequirementExemptionForm,
    name: "requirement_exemption_form_edit",
    props: true,
  },
];

export default routes;
